const REVEAL_THRESHOLD = 0.2

class AnniversarySticker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupReveal()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.revealObserver?.disconnect()
  }

  setupReveal () {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches
    if (prefersReducedMotion) return

    this.revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          this.classList.add('util-InView')
          this.revealObserver.unobserve(this)
        })
      },
      { threshold: REVEAL_THRESHOLD },
    )

    this.revealObserver.observe(this)
  }
}

if (!customElements.get('anniversary-sticker')) {
  customElements.define('anniversary-sticker', AnniversarySticker)
}
